import React from "react";
import TagDropdown from "./TagDropdown";
import "../style/RenderCheckboxes.css";

/**
 *
 * @param {String} term is the name of the dropdown item
 * @param {Number} n is the number of dropdown items
 */
function generateDropdownArray(term, n, nameArray) {
  let dropdownArray = [term]; // initialize the array with the general category
  if (!nameArray) {
    for (let i = 0; i < n; i++) {
      dropdownArray.push(`${term} ${i + 1}`);
    }
  } else {
    for (let i = 0; i < nameArray.length; i++) {
      dropdownArray.push(`${term} ${nameArray[i]}`);
    }
  }
  return dropdownArray;
}

const RenderCheckboxes = ({
  tags,
  addToState,
  removeFromState,
  closeMenuOnPress
}) => {
  const sortedTags = tags.sort();
  return sortedTags.map(tag => {
    const tagLower = tag.toLowerCase();
    let dropDownItems;
    if (tagLower === "advent") {
      dropDownItems = generateDropdownArray(tag, 4);
    } else if (tagLower === "philippians") {
      dropDownItems = generateDropdownArray(tag, null, [16]);
    } else if (tagLower === "easter") {
      dropDownItems = generateDropdownArray(tag, 7);
    } else if (tagLower === "lamentations") {
      dropDownItems = generateDropdownArray(tag, null, [3]);
    } else if (tagLower === "galatians") {
      dropDownItems = generateDropdownArray(tag, null, [6]);
    } else if (tagLower === "revelation") {
      dropDownItems = generateDropdownArray(tag, null, [21]);
    } else if (tagLower === "acts") {
      dropDownItems = generateDropdownArray(tag, null, [7]);
    } else if (tagLower === "wisdom") {
      dropDownItems = generateDropdownArray(tag, null, [16]);
    } else if (tagLower === "1 corinthians") {
      dropDownItems = generateDropdownArray(tag, null, [11]);
    } else if (tagLower === "lent") {
      dropDownItems = generateDropdownArray(tag, 5);
    } else if (tagLower === "ot") {
      dropDownItems = generateDropdownArray("OT", 4, [
        "6",
        "10",
        "14",
        "18",
        "19",
        "20",
        "2-33"
      ]);
    } else if (tagLower === "psalm") {
      dropDownItems = generateDropdownArray("Psalm", 17, [
        13,
        25,
        29,
        30,
        32,
        34,
        42,
        47,
        51,
        78,
        79,
        84,
        96,
        113,
        118,
        134,
        149
      ]);
    } else if (tagLower === "john") {
      dropDownItems = generateDropdownArray("John", 3, [1, 6, 15, 20]);
    } else if (tagLower === "isaiah") {
      dropDownItems = generateDropdownArray("Isaiah", 3, [9, 35, 45]);
    } else if (tagLower === "matthew") {
      dropDownItems = generateDropdownArray("Matthew", 3, [2, 16, 17, 28]);
    } else if (tagLower === "luke") {
      dropDownItems = generateDropdownArray("Luke", 3, [1, 2, 24]);
    }

    if (dropDownItems) {
      // instead of just rendering a  label>input[type="checkbox"]
      // this will render a dropdown
      return (
        <TagDropdown
          key={tag}
          items={dropDownItems}
          onChange={e => {
            // `name` is an HTML attribute on <input type="checkbox" />
            const { name, checked } = e.target;
            if (checked) {
              if (closeMenuOnPress) {
                // only for tablets
                closeMenuOnPress();
              }
              addToState(name, e);
            } else {
              e.target.parentNode.classList.remove("active-category");
              removeFromState(name);
            }
          }}
        />
      );
    } else {
      // just render label>input[type="checkbox"]
      return (
        <label
          className={`checkbox-label ${
            dropDownItems ? "checkbox-label--dropdown" : ""
          }${tag === "Gumpelzhaimer" ? "gump" : ""}`}
          key={tag}
        >
          <input
            onChange={e => {
              // `name` is an HTML attribute on <input type="checkbox" />
              const { name, checked } = e.target;
              if (checked) {
                if (closeMenuOnPress) {
                  closeMenuOnPress();
                }
                addToState(name, e);
              } else {
                closeMenuOnPress();
                e.target.parentNode.classList.remove("active-category");
                removeFromState(name);
              }
            }}
            type="checkbox"
            name={tag}
            className="checkbox"
          />
          {/* Give the label some text below */}
          {tag}
        </label>
      );
    }
  });
};

export default RenderCheckboxes;



// WEBPACK FOOTER //
// ./src/components/RenderCheckboxes.js